<app-special-datatable [iColumns]="columns" [iRowLinkHandler]="getRowLink" [iData$]="subscriptions" [iShowSelect]="false" [iShowExport]="false" iSortDirection="desc" iSortColumn="numericId">
</app-special-datatable>